const StorageBucket = Object.freeze({
  TRIP_IMAGES: 'trip_images',
} as const);

export type StorageBucket = (typeof StorageBucket)[keyof typeof StorageBucket];
export const allStorageBuckets: [StorageBucket, ...StorageBucket[]] = Object.values(StorageBucket) as [
  StorageBucket,
  ...StorageBucket[],
];

export default StorageBucket;
